import { render, staticRenderFns } from "./faqs_group.vue?vue&type=template&id=34d1b825&scoped=true&"
import script from "./faqs_group.vue?vue&type=script&lang=js&"
export * from "./faqs_group.vue?vue&type=script&lang=js&"
import style0 from "./faqs_group.vue?vue&type=style&index=0&id=34d1b825&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d1b825",
  null
  
)

export default component.exports